import { Cancel } from '@mui/icons-material';
import { Chip, Stack, Tooltip } from '@mui/material';
import { isEmpty } from 'ramda';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Attachment } from '../../ConversationInput.types';
import { I18nNamespace } from '~/common/types';

interface AttachmentListProps {
  attachments: Attachment[];
  onDelete: (id: string) => void;
  disabled?: boolean;
  uploadIndicator?: ReactNode;
}

export const AttachmentList = ({ attachments, onDelete, disabled, uploadIndicator }: AttachmentListProps) => {
  const { t } = useTranslation(I18nNamespace.conversation, { keyPrefix: 'AttachmentList.action' });

  if (isEmpty(attachments) && !uploadIndicator) {
    return null;
  }

  return (
    <Stack direction="row" gap={1} alignItems="center" flexWrap="wrap">
      {attachments.map((attachment) => (
        <Chip
          sx={{ maxWidth: 200 }}
          size="small"
          key={attachment.fileId}
          label={attachment.fileName}
          onDelete={() => onDelete(attachment.fileId)}
          deleteIcon={
            <Tooltip title={t('removeAttachment')} placement="top">
              <Cancel fontSize="small" />
            </Tooltip>
          }
          disabled={disabled}
        />
      ))}
      {uploadIndicator}
    </Stack>
  );
};
